import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  Alumno,
  Aula,
  Aviso,
  Circular,
  Datalogin,
  DatosApp,
  Evento,
  Trabajador,
  Informe,
  SemanaProyecto, Stream,
  Vacaciones, Fichaje, ResumenInformes, Padre
} from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) {}

  /* LLAMADAS A LA API */

  /* AUTH */
  login(data: Datalogin): Observable<{token: string}> {
    const url = this.apiUrl + 'login/check';
    return this.http.post<{token: string}>(url, data);
  }

  /////////// PRIVADO  ////////////
  /* GET */
  getVersion(): Observable<string> {
    const url = this.apiUrl + 'version/agenda';
    return this.http.get<string>(url);
  }

  getDatosApp(): Observable<DatosApp> {
    const url = this.apiUrl + 'datos';
    return this.http.get<DatosApp>(url);
  }

  getAulas(): Observable<Aula[]> {
    const url = this.apiUrl + 'aulas';
    return this.http.get<Aula[]>(url);
  }

  getCumples(): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/cumples';
    return this.http.get<Alumno[]>(url);
  }

  getComienzos(): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/comienzos';
    return this.http.get<Alumno[]>(url);
  }

  getAvisos(): Observable<Aviso[]> {
    const url = this.apiUrl + 'avisos';
    return this.http.get<Aviso[]>(url);
  }

  getAlumnos(): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/alta/todas';
    return this.http.get<Alumno[]>(url);
  }

  getAula(aula: number): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/alta/' + aula;
    return this.http.get<Alumno[]>(url);
  }

  getProgramacion(tipo: string, semana: number, curso: string): Observable<SemanaProyecto[]> {
    const url = this.apiUrl + 'programacion/' + curso + '/' + tipo + '/' + semana;
    return this.http.get<SemanaProyecto[]>(url);
  }

  getAvisosAlumno(id: number): Observable<Aviso[]> {
    const url = this.apiUrl + 'avisos/' + id;
    return this.http.get<Aviso[]>(url);
  }

  getRutinas(): Observable<Alumno[]> {
    const url = this.apiUrl + 'rutinas';
    return this.http.get<Alumno[]>(url);
  }

  getSiestas(): Observable<Evento[]> {
    const url = this.apiUrl + 'rutinas/nueva/siestas';
    return this.http.get<Evento[]>(url);
  }

  getAseos(): Observable<Evento[]> {
    const url = this.apiUrl + 'rutinas/aseos';
    return this.http.get<Evento[]>(url);
  }

  getComidas(): Observable<Evento[]> {
    const url = this.apiUrl + 'rutinas/nueva/comida';
    return this.http.get<Evento[]>(url);
  }

  getNoComidas(dest: string): Observable<Evento[]> {
    const url = this.apiUrl + 'rutinas/nueva/nocomida/' + dest;
    return this.http.get<Evento[]>(url);
  }

  getMatriculados(): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/matriculados';
    return this.http.get<Alumno[]>(url);
  }

  getNota(aula: number): Observable<Circular> {
    const url = this.apiUrl + 'circulares/' + aula + '/NOTA';
    return this.http.get<Circular>(url);
  }

  getCircular(aula: number, fecha: string): Observable<Circular[]> {
    const url = this.apiUrl + 'circulares/' + aula + '/circular/' + fecha;
    return this.http.get<Circular[]>(url);
  }

  getSalidas(): Observable<Alumno[]> {
    const url = this.apiUrl + 'rutinas/salidas';
    return this.http.get<Alumno[]>(url);
  }

  getEntradas(): Observable<Alumno[]> {
    const url = this.apiUrl + 'alumnos/entradas';
    return this.http.get<Alumno[]>(url);
  }

  getFichajes(): Observable<[Trabajador[], Fichaje[]]> {
    const url = this.apiUrl + 'controles';
    return this.http.get<[Trabajador[], Fichaje[]]>(url);
  }

  getInformes(): Observable<ResumenInformes[]> {
    const url = this.apiUrl + 'informes';
    return this.http.get<ResumenInformes[]>(url);
  }

  getInforme(id: number, curso: string, trimestre: number): Observable<Informe> {
    const url = this.apiUrl + 'informes/alumno/' + id + '/' + curso + '/' + trimestre;
    return this.http.get<Informe>(url);
  }

  getStreams = (): Observable<Stream[]> => {
    const url = this.apiUrl + 'streams';
    return this.http.get<Stream[]>(url);
  }

  getStreamsAula = (aula: number): Observable<Stream[]> => {
    const url = this.apiUrl + 'streams/' + aula;
    return this.http.get<Stream[]>(url);
  }

  getStreamAula = (aula: number): Observable<Stream> => {
    const url = this.apiUrl + 'streams/start/' + aula;
    return this.http.get<Stream>(url);
  }

  stopStream= (uuid: string): Observable<void> => {
    const url = this.apiUrl + 'streams/stop/' + uuid;
    return this.http.get<void>(url);
  }

  getVacaciones(): Observable<Vacaciones[]> {
    const url = this.apiUrl + 'vacaciones';
    return this.http.get<Vacaciones[]>(url);
  }

  getEvento(id: number): Observable<Evento> {
    const url = this.apiUrl + 'eventos/' + id + '/actual';
    return this.http.get<Evento>(url);
  }

  getAlumno(id: number): Observable<[Alumno, Padre, Padre]> {
    const url = this.apiUrl + 'alumnos/nuevo/' + id;
    return this.http.get<[Alumno, Padre, Padre]>(url);
  }

  getListadoAlergias(): Observable<string> {
    const url = this.apiUrl + 'listados/nombres/alergias';
    return this.http.get<string>(url);
  }

  getAgenda = (id: number): Observable<[Evento[],Array<{salida: boolean}>,Circular[]]> => {
    const url = this.apiUrl + 'app/agenda/' + id;
    return this.http.get<[Evento[],Array<{salida: boolean}>,Circular[]]>(url);
  }

  getNotas = (aula: number): Observable<Circular[]> => {
    const url = this.apiUrl + 'circulares/' + aula;
    return this.http.get<Circular[]>(url);
  }

  descartarAviso = (id: number): Observable<void> => {
    const url = this.apiUrl + 'avisos/descartar/' + id;
    return this.http.get<void>(url);
  }

  getCalendario = (curso: string): Observable<any> => {
  const url = this.apiUrl + 'agenda/educadoras/' + curso;
  return this.http.get<any>(url);
}

  /* POST */

  notificar(datos: {idAlumno: number, nombreCompleto: string, comentario: string}): Observable<number> {
    const url = this.apiUrl + 'avisos/mensaje/notificacion/alumno';
    return this.http.post<number>(url, datos);
  }

  updateRutina(datos: {id: number, campo: string, valor: boolean}): Observable<any> {
    const url = this.apiUrl + 'rutinas/update/nueva/' + datos.id;
    return this.http.post<any>(url, datos);
  }

  setSiesta(datos: Evento): Observable<any> {
    const url = this.apiUrl + 'eventos/nueva/siesta/' + datos.id;
    return this.http.post<any>(url, datos);
  }

  setRutina(datos: {id: number, rutina: string, valor: string}): Observable<any> {
    const url = this.apiUrl + 'eventos/' + datos.id + '/rutinas';
    return this.http.post<any>(url, datos);
  }

  altaAlumno(datos: Alumno): Observable<any> {
    const url = this.apiUrl + 'alumnos/' + datos.id + '/alta';
    return this.http.post<any>(url, {aula: datos.aula});
  }

  uploadFileImage = (file: FormData): Observable<string> => {
    const url = this.apiUrl + 'uploads/savefile/imagen';
    return this.http.post<string>(url, file);
  }

  uploadPDF = (file: FormData): Observable<string> => {
    const url = this.apiUrl + 'uploads/savefile/doc';
    return this.http.post<string>(url, file);
  }

  uploadImageAvatar = (file: FormData): Observable<string> => {
    const url = this.apiUrl + 'uploads/savefile/avatar';
    return this.http.post<string>(url, file);
  }

  updateSalida(id: number): Observable<any> {
    const url = this.apiUrl + 'rutinas/salida/nueva/' + id;
    return this.http.post<any>(url, {});
  }

  setPIN(datos: {id: number, pin: string}): Observable<any> {
    const url = this.apiUrl + 'controles/updatePin/' + datos.id;
    return this.http.post<any>(url, {pin: datos.pin});
  }

  saveMasivo(datos: {listado: number[], rutina: string, estate: boolean}): Observable<any> {
    const url = this.apiUrl + 'eventos/masivo';
    return this.http.post<any>(url, datos);
  }

  validarInforme(datos: {idAlumno: number, trimestre: number, curso: string}): Observable<any> {
    const url = this.apiUrl + 'informes/validar';
    return this.http.post<any>(url, datos);
  }

  salida(id: number, datos: object): Observable<any> {
    const url = this.apiUrl + 'eventos/' + id + '/salida';
    return this.http.post<any>(url, datos);
  }

  salidaTodos(ids: number[]): Observable<void> {
    const url = this.apiUrl + 'eventos/salida/todos';
    return this.http.post<void>(url, {ids: ids});
  }

  setEnfermedad(datos: Evento): Observable<any> {
    const url = this.apiUrl + 'eventos/' + datos.child + '/enfermo';
    return this.http.post<any>(url, {causa: datos.causa});
  }

  updateEvento(datos: Evento): Observable<any> {
    const url = this.apiUrl + 'eventos/' + datos.child;
    return this.http.post<any>(url, {data: datos});
  }

  updateAlumno(datos: {foto: string, fnac: string, nofnac: boolean, yearfnac: number}, id: number): Observable<any> {
    const url = this.apiUrl + 'alumnos/' + id + '/update';
    return this.http.post<any>(url, {
      data: datos
    })
  }

  updateNota(datos: Circular): Observable<any> {
    const url = this.apiUrl + 'notas';
    return this.http.post<any>(url, datos);
  }

  deleteObjet = (data: string): Observable<void> => {
    const url = this.apiUrl + 'uploads/delete';
    return this.http.post<void>(url, {url: data});
  }

  deleteObjets = (data: string[]): Observable<void> => {
    const url = this.apiUrl + 'uploads/deleteobjects';
    return this.http.post<void>(url, {urls: data});
  }

  /* PUT */
  updateCircular(datos: {aula: number, imagen: string, file: string, texto: string, fecha: string}): Observable<void> {
    const url = this.apiUrl + 'circulares/' + datos.aula + '/circular/' + datos.fecha;
    return this.http.put<void>(url, datos);
  }

  putFichaje(id: number): Observable<any> {
    const url = this.apiUrl + 'controles/fichar/' + id;
    return this.http.put<any>(url, {});
  }

  /* DELETE */
  borrarCircular(aula: number, tipo: string, fecha: string): Observable<any> {
    const url = this.apiUrl + 'circulares/' + aula + '/' + tipo + '/' + fecha;
    return this.http.delete<any>(url);
  }

  deleteAviso(id: number): Observable<any> {
    const url = this.apiUrl + 'avisos/' + id;
    return this.http.delete<any>(url);
  }

}
